export default {
  400: '请求无效',
  403: '权限不足，禁止访问',
  404: '请求资源不存在',
  406: '请求的数据格式错误',
  500: '服务器发生错误'
}
